import { createTheme } from '@mui/material/styles';

export const createCorporateTheme = (mode = 'light') => {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: mode === 'light' ? '#0D4B79' : '#4689b9',
        light: mode === 'light' ? '#4689b9' : '#6fa5cf',
        dark: mode === 'light' ? '#08355a' : '#29618f',
        contrastText: '#ffffff',
      },
      secondary: {
        main: mode === 'light' ? '#3e4c59' : '#a1acb8',
        light: mode === 'light' ? '#6c7883' : '#c4cbd4',
        dark: mode === 'light' ? '#2d3742' : '#7e8995',
        contrastText: '#ffffff',
      },
      background: {
        default: mode === 'light' ? '#f5f7fa' : '#171c21',
        paper: mode === 'light' ? '#ffffff' : '#242c35',
      },
      text: {
        primary: mode === 'light' ? '#3e4c59' : '#e0e4e9',
        secondary: mode === 'light' ? '#6c7883' : '#a1acb8',
      },
    },
    typography: {
      fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
      h1: { fontWeight: 600 },
      h2: { fontWeight: 600 },
      h3: { fontWeight: 600 },
      h4: { fontWeight: 600 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
      button: {
        textTransform: 'none',
        fontWeight: 600,
        letterSpacing: 0.5,
      },
    },
    shape: {
      borderRadius: 6,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 4,
            fontWeight: 600,
            boxShadow: 'none',
            padding: '8px 20px',
            '&:hover': {
              boxShadow: mode === 'light'
                ? '0 3px 6px rgba(13, 75, 121, 0.2)'
                : '0 3px 6px rgba(70, 137, 185, 0.2)',
            },
          },
          contained: {
            textTransform: 'none',
            letterSpacing: 0.5,
          },
          outlined: {
            borderWidth: 1.5,
            '&:hover': {
              borderWidth: 1.5,
            },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: mode === 'light'
              ? '0 1px 3px rgba(0, 0, 0, 0.1)'
              : '0 1px 3px rgba(0, 0, 0, 0.3)',
            backgroundColor: mode === 'light' ? '#ffffff' : '#242c35',
            color: mode === 'light' ? '#3e4c59' : '#e0e4e9',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            boxShadow: mode === 'light'
              ? '0 2px 8px rgba(0, 0, 0, 0.06)'
              : '0 2px 8px rgba(0, 0, 0, 0.2)',
            border: mode === 'light'
              ? '1px solid #e8ecf1'
              : '1px solid #313c47',
            transition: 'transform 0.2s, box-shadow 0.2s',
            '&:hover': {
              transform: 'translateY(-3px)',
              boxShadow: mode === 'light'
                ? '0 8px 24px rgba(0, 0, 0, 0.1)'
                : '0 8px 24px rgba(0, 0, 0, 0.3)',
            },
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: mode === 'light' ? '#f5f7fa' : '#1e242b',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            fontWeight: 600,
            color: mode === 'light' ? '#3e4c59' : '#e0e4e9',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 4,
            fontWeight: 500,
          },
        },
      },
    },
  });
};